import { FieldModel } from './field';

export enum FieldGroupPlacement {
  BookingPage = 0,
  BookingModal = 1,
  CreateNotificationRequestPage = 2,
  Pinboard = 3,
}

export class FieldGroupModel {
  static fromAny = (fieldModel: any) =>
    new FieldGroupModel(
      fieldModel.id,
      fieldModel.placement,
      (fieldModel.fields || []).map((f: any) => FieldModel.fromAny(f)),
      fieldModel.order,
      fieldModel.optionId
    );

  constructor(
    public id: string,
    public placement: FieldGroupPlacement,
    public fields: Array<FieldModel>,
    public order: string,
    public optionId?: string
  ) {}
}
